import {Action, action} from 'easy-peasy';

export enum DummyStorySlug {
    Agents = 'agents',
    Customers = 'customers',
    Teams = 'teams',
}

export interface ActiveDummyStorySlugModel {
    activeDummyStorySlug: DummyStorySlug | '';
    setActiveDummyStory: Action<ActiveDummyStorySlugModel, DummyStorySlug>;
}

export default <ActiveDummyStorySlugModel>{
    activeDummyStorySlug: '',
    setActiveDummyStory: action((state, storySlug) => {
        state.activeDummyStorySlug = storySlug;
    }),
};
